const API_URL = window.envvars.API_URL;

const get = async (path, query) => {
  const queryString = new URLSearchParams(query || {}).toString();
  const response = await fetch(`${API_URL}${path}?${queryString}`, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error('Something went wrong.');
  }
};

const post = async (path, body) => {
  const isFormData = body instanceof FormData;
  const response = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    cache: 'no-cache',
    body: isFormData ? body : JSON.stringify(body),
    headers: isFormData ? {} : {
      'Content-Type': 'application/json',
    },
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error('Something went wrong.');
  }
};


export const getEvaluation = async (profile) => {
  return await get('/v1/skills/evaluation/', { eid: profile });
};

export const getNext = async (data) => {
  return await post('/v1/skills/evaluation/next/', data);
};

export const getPreview = async (question) => {
  return await get('/v1/skills/evaluation/preview/', { question });
};

export const getRedirect = async (rid) => {
  return await get('/v1/skills/evaluation/redirect/', { rid });
};
